var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEducacionContinua = function SvgEducacionContinua(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 79 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#educacion-continua_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.36 46.997h-1.313V18.581c0-4.28-3.545-7.746-7.895-7.746H62.28c-1.45 0-2.628 1.156-2.628 2.578 0 1.423 1.178 2.578 2.628 2.578h4.87c1.45 0 2.628 1.155 2.628 2.578v28.416H9.222V18.58c0-1.423 1.177-2.578 2.627-2.578h4.87c1.451 0 2.628-1.155 2.628-2.578 0-1.422-1.177-2.577-2.627-2.577h-4.87c-4.364 0-7.896 3.477-7.896 7.745v28.416H2.64c-1.45 0-2.627 1.155-2.627 2.578v5.168c0 4.28 3.544 7.745 7.895 7.745h63.197c4.363 0 7.895-3.477 7.895-7.745v-5.168c0-1.423-1.177-2.578-2.627-2.578m-2.628 7.746c0 1.422-1.177 2.577-2.627 2.577H7.895c-1.45 0-2.627-1.155-2.627-2.577v-2.578h68.465v2.578h.012Z",
    fill: "#03F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.616 41.83h5.267c1.45 0 2.628-1.156 2.628-2.578 0-1.423-1.178-2.578-2.628-2.578h-5.267c-1.45 0-2.628 1.155-2.628 2.578 0 1.422 1.178 2.577 2.628 2.577ZM14.488 39.252c0 1.422 1.178 2.577 2.628 2.577h5.267c1.45 0 2.628-1.155 2.628-2.577 0-1.423-1.178-2.578-2.628-2.578h-5.267c-1.45 0-2.628 1.155-2.628 2.578Z",
    fill: "#03F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.93 18.58c0 9.984-8.254 18.082-18.43 18.082-10.175 0-18.43-8.098-18.43-18.081C21.07 8.598 29.312.5 39.5.5c10.188 0 18.43 8.098 18.43 18.08Z",
    fill: "#EB3D14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "educacion-continua_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h79v62H0z"
  })))));
};
export default SvgEducacionContinua;